import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

/**
 * Legacy route guard.
 *
 * The previous "register your shop from inside a player account" flow
 * has been retired. Per the strict-separation redesign, shops MUST sign up
 * via the dedicated /register-shop path BEFORE creating a player account.
 *
 * This component handles all old deep-links to /shop-onboarding:
 *   - Logged-out users → /register-shop (real signup)
 *   - Logged-in players → /home with an explanatory toast
 *   - Logged-in shop owners → their existing shop dashboard
 */
export default function ShopOnboardingRedirect() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      navigate('/register-shop', { replace: true });
      return;
    }
    if (user?.home_shop_id) {
      navigate(`/shop/${user.home_shop_id}`, { replace: true });
      return;
    }
    toast.error(
      "Shop accounts are separate from player accounts. Sign out and sign up at /register-shop with a different email to create a shop.",
      { duration: 7000 }
    );
    navigate('/home', { replace: true });
  }, [user, navigate]);

  return null;
}
